<template>
    <div class="oops_banner">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="oops_banner_content_box">
                        <div class="row align-items-center">
                            <div class="col-md-7 order-2 order-md-1">
                                <div class="oops_banner_content">
                                    <h1>Oops</h1>
                                    <p>
                                        We are unable to provide you with an
                                        offer at this time using the details
                                        provided
                                    </p>
                                    <p>
                                        Please change the criteria (bed, bath,
                                        garage) and try again to get your offer.
                                    </p>
                                    <a
                                        href="javascript:void(0)"
                                        v-on:click="goBack()"
                                        >BACK
                                    </a>
                                </div>
                            </div>
                            <div
                                class="col-md-5 order-1 order-md-2 mb-4 mb-md-0"
                            >
                                <div class="oops_banner_content_image">
                                    <img
                                        src="/assets/images/oops_banner_content_image.png"
                                        class="img-fluid"
                                        alt="Failed Valuation"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Valuation_Failed_Direct",
    methods: {
        goBack() {
            this.$emit("goToBack");
        },
    },
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    font-family: "helveticaregular";
    position: relative;
}

a {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0;
}

p {
    margin: 0;
    padding: 0;
    font-size: 15px;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
}

::-webkit-scrollbar {
    width: 7px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
    background-color: #E11F26;
}

/***header****/
header.new_header {
    background: #e15d5d;
    box-shadow: 0px 2px 5px 0px #00000040;
    padding: 10px 0 15px;
}

.new_navmain_menu .navbar-brand img {
    width: 175px;
}

.new_navmain_menu .navbar {
    padding: 0;
}

.new_navmain_menu ul.navbar-nav li a {
    padding: 0 !important;
    line-height: 1;
    color: #ffffff;
    font-size: 17px;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    text-transform: uppercase;
    font-family: "helveticabold";
}

.new_navmain_menu ul.navbar-nav li:not(:last-child) {
    margin-right: 54px;
}

.login_button span svg {
    font-size: 25px;
    color: #fff;
}

.login_button a {
    background: #fff;
    display: inline-block;
    line-height: 1;
    text-transform: uppercase;
    font-family: "helveticabold";
    padding: 9px;
    margin-right: 40px;
}

.login_button {
    display: flex;
    align-items: center;
    margin-left: 55px;
}

.login_button span {
    display: inline-block;
    line-height: 1;
}

/****banner****/
.new_banner_content_box {
    background: #e7f1ff;
    border-radius: 29px;
    padding: 30px;
}

.new_banner_content_title h1 {
    font-family: "helveticabold";
    line-height: 1;
    font-size: 40px;
}

.new_banner_content_title p span img {
    width: 11px;
}

.new_banner_content_title p span {
    display: inline-block;
    line-height: 0;
    margin-right: 5px;
}

.new_banner_content_title p {
    display: flex;
    align-items: center;
    font-size: 17px;
    color: #414141;
    margin-top: 6px;
}

.new_banner_content_title {
    margin-bottom: 10px;
}

.new_banner_content_price h2 {
    font-family: "helveticabold";
    line-height: 1;
    font-size: 44px;
    margin-right: 12px;
}

.new_banner_content_price {
    display: flex;
    align-items: flex-end;
}

.new_banner_content_price small {
    color: #525252;
    font-size: 15px;
}

.new_banner_content_price {
    margin-bottom: 20px;
}

ul.slider_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

ul.slider_title li {
    color: #414141;
    font-family: "helveticabold";
    font-size: 15px;
}

ul.slider_price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
}

ul.slider_price li {
    color: #4c4c4c;
    font-family: "helveticabold";
    font-size: 19px;
}

.new_banner_content_slide small {
    color: #525252;
    font-size: 15px;
    display: block;
    line-height: 1;
}

.slider_bar {
    width: 100%;
    height: 5px;
    background: #b1b1b1;
    border-radius: 23px;
    position: relative;
    margin: 21px 0px;
}

.slider_bar:before {
    content: "";
    position: absolute;
    background: #E11F26;
    height: 10px;
    width: 50%;
    border-radius: 36px;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}

.slider_bar_ball:before {
    content: "";
    position: absolute;
    height: 25px;
    width: 25px;
    background: #E11F26;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    border-radius: 26px;
}

.slider_bar_ball {
    position: absolute;
    overflow: hidden;
    height: 25px;
    width: 25px;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0;
    border-radius: 42px;
}

.slider_bar_ball:after {
    content: "";
    position: absolute;
    height: 21px;
    width: 21px;
    background: #f5f7f8c9;
    top: -8px;
    bottom: 0;
    margin: auto;
    left: 8px;
    right: 0;
    border-radius: 26px;
}

.slider_bar:after {
    content: "";
    position: absolute;
    background: #f5f7f8c9;
    height: 5px;
    width: 5px;
    top: -1px;
    bottom: 0;
    margin: auto;
    left: 0;
    right: -11px;
    border-radius: 30px;
}

.new_banner_content_button a {
    display: inline-block;
    line-height: 1;
    background: #E11F26;
    padding: 6px 9px;
    color: #fff;
    border: 1px solid #E11F26;
    font-size: 18px;
    border-radius: 4px;
}

.new_banner_content_button {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.new_banner_content_button a:last-child {
    background: #fff;
    color: #E11F26;
    margin-left: 33px;
}

.new_banner_content_button {
    margin-top: 20px;
}

.new_property_details_bredc_content ul {
    display: flex;
    align-items: center;
}

.new_property_details_bredc_content ul li:not(:last-child) {
    margin-right: 29px;
}

.new_property_details_bredc_content ul li a {
    color: #000;
    font-size: 17px;
}

.new_property_details_bredc_content ul li {
    color: #e15d5d;
    position: relative;
}

.new_property_details_bredc_content ul li:not(:last-child):before {
    content: ">";
    position: absolute;
    right: -19px;
    top: 0;
    bottom: 0;
    margin: auto;
    color: #000;
    font-size: 15px;
}

.new_property_details_bredc {
    padding: 25px 0;
}

.new_property_details_bredc_content ul {
    display: flex;
    align-items: center;
}

.new_property_details_bredc_content ul li:not(:last-child) {
    margin-right: 29px;
}

.new_property_details_bredc_content ul li a {
    color: #000;
    font-size: 17px;
}

.new_property_details_bredc_content ul li {
    color: #e15d5d;
    position: relative;
}

.new_property_details_bredc_content ul li:not(:last-child):before {
    content: ">";
    position: absolute;
    right: -19px;
    top: 0;
    bottom: 0;
    margin: auto;
    color: #000;
    font-size: 15px;
}

.new_property_details_bredc {
    padding: 25px 0;
}

.new_property_details_share_content ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: "helveticabold";
    color: #5d96e1;
    font-size: 17px;
}

.new_property_details_share_content ul li img {
    width: 18px;
}

.new_property_details_share_content ul li {
    display: flex;
    align-items: center;
}

.new_property_details_share_content ul li span {
    display: block;
    line-height: 0;
    margin-left: 6px;
}

.new_property_details_share {
    padding-bottom: 20px;
}

/***new_property_details_image***/
.new_property_details_image_main {
    overflow: hidden;
    position: relative;
    border-radius: 15px;
    cursor: pointer;
}

.new_property_details_image_main img {
    width: 100%;
    height: 430px;
}

.new_property_details_image_main span {
    position: absolute;
    bottom: 21px;
    right: 21px;
    z-index: 9;
    background: #fff;
    display: inline-block;
    padding: 3px 10px;
    font-size: 15px;
    border-radius: 27px;
}

.new_property_details_image_sub {
    overflow: hidden;
    position: relative;
    border-radius: 15px;
    cursor: pointer !important;
}

.new_property_details_image_sub img {
    width: 100%;
    height: 208px;
}

.new_property_details_image_sub:not(:last-child) {
    margin-bottom: 14px;
}

.new_property_details_image_sub:last-child:before {
    content: "";
    position: absolute;
    background: #00000061;
    height: 100%;
    width: 100%;
    z-index: 9;
}

.new_property_details_image_sub span {
    position: absolute;
    top: 0;
    margin: auto;
    z-index: 999;
    color: #fff;
    font-family: "helveticabold";
    font-size: 51px;
    line-height: 1;
    display: flex;
    justify-content: center;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
}

.new_property_details_image_sub small {
    position: absolute;
    top: 66px;
    margin: auto;
    z-index: 999;
    color: #fff;
    font-family: "helveticabold";
    font-size: 17px;
    line-height: 1;
    display: flex;
    justify-content: center;
    bottom: 0;
    left: 10px;
    right: 0;
    align-items: center;
}

/***price****/
.new_property_details_extra_points ul {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.new_property_details_extra_points li {
    width: 40%;
}

.new_property_details_extra_points li:last-child {
    width: 20%;
}

.new_property_details_extra_points span.small_new {
    display: inline-block;
    line-height: 0;
    margin-right: 6px;
}

.new_property_details_extra_points span.small_new img {
    width: 20px;
}

.new_property_details_extra_points ul li {
    display: flex;
    align-items: flex-start;
    line-height: 1;
}

.new_property_details_extra_points ul li:nth-child(2) img {
    width: 14px;
}

.new_property_details_extra_points ul li:last-child {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.new_property_details_extra_points ul li:last-child span.big_new img {
    width: 26px;
}

.new_property_details_extra_points ul li:last-child span.big_new:last-child {
    margin-left: 15px;
}

.new_property_details_extra_points ul li:last-child span.big_new {
    cursor: pointer;
}

.new_property_details_extra {
    padding: 30px 0;
}

.new_custom_button {
    color: #fff;
    padding: 3px 30px;
    display: inline-block;
    background: #E11F26;
    border-radius: 5px;
}

.new_custom_button:hover {
    color: #fff;
}

.new_property_details_extra_price {
    text-align: center;
}

.new_property_details_extra_price h2 {
    color: #000;
    font-family: "helveticabold";
    font-size: 37px;
    line-height: 1;
    margin-bottom: 15px;
}

.new_property_details_extra_price p {
    display: flex;
    align-items: baseline;
    font-family: "helveticabold";
    line-height: 1;
    text-align: left;
    color: #E11F26;
}

.new_property_details_extra_price p span {
    display: block;
    margin-right: 8px;
}

.new_property_details_descontent_title,
.new_property_details_descontent_amenities_title,
.new_property_details_descontent_property_details_title {
    text-align: center;
    font-family: "helveticabold";
    color: #E11F26;
    margin-bottom: 33px;
}

.new_property_details_descontent_title h3,
.new_property_details_descontent_amenities_title h3,
.new_property_details_descontent_property_details_title h3 {
    line-height: 1;
}

.new_property_details_descontent_points ul {
    display: flex;
    align-items: center;
    flex-flow: wrap;
}

.new_property_details_descontent_points ul li {
    width: 25%;
}

.new_property_details_descontent_points ul li {
    display: flex;
    align-items: self-end;
    margin-bottom: 15px;
    line-height: 1;
}

.new_property_details_descontent_points ul li span {
    display: inline-block;
    line-height: 0;
    margin-right: 1px;
}

.new_property_details_descontent_points ul li span img {
    width: 73%;
}

.new_property_details_descontent_points {
    margin-bottom: 10px;
}

.new_property_details_descontent_box p {
    text-align: justify;
    margin-bottom: 32px;
}

.new_map_box iframe {
    width: 100%;
    height: 328px;
    display: block;
}

.new_map_box {
    margin-top: 40px;
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.1));
    border-radius: 38.8774px;
    overflow: hidden;
    margin-bottom: 40px;
}

.new_property_details_descontent_amenities {
    margin-bottom: 25px;
}

.new_property_details_descontent_amenities ul {
    display: flex;
    flex-wrap: wrap;
}

.new_property_details_descontent_amenities ul li {
    font-size: 16px;
    position: relative;
    margin-left: 30px;
    width: 35%;
}

.new_property_details_descontent_amenities ul li:not(:last-child) {
    margin-bottom: 11px;
}

.new_property_details_descontent_amenities ul li:before {
    content: "";
    position: absolute;
    background: url(/assets/images/new_like_sm.png);
    height: 15px;
    width: 18px;
    background-repeat: no-repeat !important;
    left: -30px;
    top: 2px;
    background-size: 100% 100%;
}

.new_property_details_descontent_property_details ul li {
    display: flex;
    position: relative;
    color: #4b4b4b;
    margin-left: 35px;
}

.new_property_details_descontent_property_details ul li:before {
    content: "";
    position: absolute;
    background: url(/assets/images/tick_new.png);
    height: 17px;
    width: 17px;
    background-repeat: no-repeat !important;
    left: -35px;
    top: 2px;
    background-size: 100% 100%;
}

.new_property_details_descontent_property_details ul li:after {
    content: "";
    position: absolute;
    opacity: 0.5;
    filter: blur(1px);
    width: 105%;
    height: 1px;
    background: #09337063;
    bottom: -10px;
    left: -34px;
}

.new_property_details_descontent_property_details ul li:not(:last-child) {
    margin-bottom: 22px;
}

.new_property_details_descontent_property_details ul li span {
    display: block;
    width: 30%;
}

.new_property_details_descontent_property_details
    ul
    li:last-child
    span:last-child {
    width: 70%;
}

.more_fact_feature {
    margin-top: 70px;
}

.more_fact_feature_button button {
    border: none;
    background: #E11F26;
    color: #fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 1;
    padding: 7px 13px;
}

.more_fact_feature_button button img {
    width: 21px;
}

.more_fact_feature_button button span {
    display: block;
    margin-right: 8px;
}

button#more_fact_feature_button_show svg,
button#more_fact_feature_button_hide svg {
    margin-left: 8px;
}

.more_fact_feature_button {
    margin-bottom: 35px;
}

.more_fact_feature_box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

.show_main_det {
    height: auto !important;
    visibility: visible !important;
    overflow: auto !important;
    -webkit-transition: all 0.3s ease-in-out !important;
    transition: all 0.3s ease-in-out !important;
}

.more_fact_feature_box1,
.more_fact_feature_box2 {
    width: 44%;
}

.more_fact_feature_box_item span {
    font-family: "helveticabold";
    display: block;
    font-size: 18px;
    line-height: 1;
    margin-bottom: 15px;
}

.more_fact_feature_box_item ul li {
    font-size: 15px;
}

.more_fact_feature_box_item ul li:not(:last-child) {
    margin-bottom: 8px;
}

.more_fact_feature_box_item:not(:last-child) {
    margin-bottom: 40px;
}

.new_property_details_descontent_property_details ul li:before {
    content: "";
    position: absolute;
    background: url(/assets/images/tick_new.png);
    height: 17px;
    width: 17px;
    background-repeat: no-repeat !important;
    left: -35px;
    top: 2px;
    background-size: 100% 100%;
}

.new_video_box {
    background: url(/assets/images/play_back.png);
    background-repeat: no-repeat !important;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 67px;
    margin-top: 45px;
    margin-bottom: 35px;
}

.new_video_box_image img {
    width: 90%;
}

.new_video_box_image {
    text-align: center;
}

.new_video_box_button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
}

.new_video_box_button span {
    font-size: 46px;
    font-family: "helveticabold";
    line-height: 1;
    margin-top: 29px;
}

.new_video_box_button button {
    background: transparent;
    border: none;
}

.new_video_box_button button img {
    width: 50px;
}

.new_property_details_descontent {
    padding-bottom: 50px;
}

.new_banner_side_image img {
    max-width: 106%;
    position: absolute;
    left: -53px;
}

.new_banner_side_image {
    position: relative;
}

.new_comparable_home .new_property_card_image img {
    width: 100%;
}

.new_comparable_home .new_property_card_content {
    padding: 14px;
}

.new_comparable_home .new_property_card {
    border-radius: 19px;
    overflow: hidden;
    box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
}

.new_comparable_home .new_property_card_title span {
    display: block;
    color: #4b4b4b;
    font-size: 15px;
    border-bottom: 1px solid #70707085;
    padding-bottom: 7px;
    margin-bottom: 16px;
}

.new_comparable_home .new_property_card_ame ul li {
    color: #373738;
    font-size: 12px;
    width: 50%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.new_comparable_home .new_property_card_ame ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.new_comparable_home .new_property_card_ame ul li span {
    display: block;
    line-height: 0;
    margin-right: 5px;
}

.new_comparable_home .new_property_card_ame ul li span img {
    width: 18px;
}

.new_comparable_home .new_property_card_ame {
    border-bottom: 1px solid #70707085;
    padding-bottom: 7px;
    margin-bottom: 10px;
}

.new_comparable_home .new_property_card_p p {
    color: #373738;
    font-family: "helveticabold";
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 5px;
}

.new_comparable_home .new_property_card_p span {
    display: block;
    color: #373738;
    font-size: 15px;
}

.new_comparable_home .new_property_card_p span small {
    font-size: 15px;
    text-decoration: line-through;
}

.new_comparable_home .new_comparable_home_title {
    text-align: center;
    margin-bottom: 40px;
}

.new_comparable_home .new_comparable_home_title span {
    font-family: "helveticabold";
    line-height: 1;
    color: #E11F26;
    font-size: 29px;
}

.new_comparable_home {
    margin-top: 80px;
}

.new_comparable_home .new_property_card_image {
    position: relative;
}

.new_comparable_home .new_property_card_image span.detatched_new {
    position: absolute;
    top: 10px;
    background: #ffffffd9;
    font-size: 13px;
    padding: 3px 9px;
    left: 14px;
    border-radius: 5px;
}

.new_comparable_home .new_property_card_image span.sale_new {
    position: absolute;
    top: 10px;
    background: #ffffffd9;
    font-size: 13px;
    padding: 3px 9px;
    right: 14px;
    border-radius: 5px;
}

.new_comparable_home .new_property_card_image span.hour_new {
    position: absolute;
    bottom: 10px;
    background: #ffffffd9;
    font-size: 13px;
    padding: 3px 9px;
    right: 14px;
    border-radius: 5px;
}

.new_comparable_home .new_property_card_p.no_onli span small {
    text-decoration: none;
}

.new_way_buy_home {
    padding: 90px 0 20px;
}

.new_way_buy_home_title {
    text-align: center;
    margin-bottom: 140px;
}

.new_way_buy_home_title h5 {
    font-family: "helveticabold";
    line-height: 1;
    color: #E11F26;
    font-size: 28px;
}

.new_way_buy_home_title span {
    color: #b1b1b1;
    display: block;
    font-size: 22px;
    line-height: 1;
    margin-top: 25px;
}

.new_way_buy_home_content {
    padding: 142px 30px 30px;
    background: #ffffff;
    box-shadow: 0px 0px 42px -10px rgba(0, 0, 0, 0.19);
    z-index: -9;
    height: 100%;
}

.new_way_buy_home_content_image {
    position: absolute;
    background: #f5f7f8;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 190px;
    height: 190px;
    border-radius: 104px;
    left: 0;
    right: 0;
    margin: auto;
    top: -86px;
}

.new_way_buy_home_content_image img {
    width: 110px;
}

.new_way_buy_home_content_title {
    z-index: 9;
    position: absolute;
    top: 81px;
}

.new_way_buy_home_content_title span {
    color: #414141;
    font-family: "helveticabold";
    line-height: 1;
    display: block;
    font-size: 20px;
}

.new_way_buy_home_content_title small {
    color: #b1b1b1;
    font-size: 14px;
    display: block;
    margin-top: 5px;
}

.new_way_buy_home_content_p p {
    color: #b1b1b1;
    text-align: justify;
    font-size: 14px;
}

.new_way_buy_home_content_button a {
    font-family: "helveticabold";
    line-height: 1;
    color: #E11F26;
    font-size: 18px;
    margin-top: 12px;
    display: inline-block;
}

.new_secude_form {
    background: #ffffff;
    border-radius: 24.9165px;
    box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
    padding: 25px;
    position: sticky;
    top: 100px;
}

.new_secude_form_title {
    text-align: center;
    font-family: "helveticabold";
    color: #E11F26;
    margin-bottom: 33px;
    font-size: 22px;
    line-height: 1;
}

.new_secude_form_box {
    border: 2px dashed #E11F26;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 45px;
}

.new_secude_form_box .form-group {
    margin-bottom: 9px;
}

.new_secude_form_box .form-group label {
    margin: 0;
    font-size: 15px;
}
.new_secude_form_box .form-group .form-control {
    background: #f2f2f266;
}

.new_secude_form_box .form-group .form-control:focus {
    border-color: #ced4da;
    box-shadow: none;
}

.new_secude_form_box .form-check {
    margin-top: 16px;
    font-size: 15px;
}

.new_secude_form_box button {
    border: none;
    width: 100%;
    padding: 7px;
    background: #E11F26;
    border-radius: 6.22912px;
    color: #fff;
    font-size: 18px;
    margin-top: 17px;
}

.new_quicklink span {
    display: block;
    font-size: 20px;
    font-family: "helveticabold";
    margin-bottom: 10px;
}

.new_quicklink ul li a {
    color: #E11F26;
    font-size: 17px;
    text-decoration: underline;
}

.new_quicklink ul li:not(:last-child) {
    margin-bottom: 6px;
}

/****new-css****/
.oops_banner {
    padding-top: 60px;
    padding-bottom: 60px;
}
.oops_banner_content_box {
    background: #ffffff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 25px;
    padding: 45px 20px 45px 80px;
}

.oops_banner_content h1 {
    font-family: "helveticabold";
    line-height: 1;
    font-size: 50px;
    margin-bottom: 20px;
}

.oops_banner_content p {
    font-size: 19px;
}

.oops_banner_content {
    margin-right: 94px;
}

.oops_banner_content p:not(:last-child) {
    margin-bottom: 19px;
}

.oops_banner_content a {
    color: #fff;
    padding: 7px 22px;
    background: #E11F26;
    border-radius: 5px;
}
/**************responsive***********/
@media screen and (max-width: 2560px) {
}

@media screen and (max-width: 1500.98px) {
}

@media screen and (max-width: 1199.98px) {
    .new_banner_content_title h1 {
        font-size: 39px;
    }
    .new_banner_content_price h2 {
        font-size: 40px;
        margin-right: 10px;
        margin-bottom: 12px;
    }
    .new_banner_content_price {
        flex-wrap: wrap;
    }
    .new_video_box_button span {
        font-size: 38px;
    }
}

@media screen and (max-width: 991.98px) {
    ul.navbar-nav,
    .login_button a {
        display: none;
    }
    .new_banner_content_price h2 {
        margin-bottom: 0;
        font-size: 33px;
    }
    .new_property_details_image_sub img {
        height: 168px;
    }
    .new_property_details_image_main img {
        height: 350px;
    }
    .new_property_details_extra_points ul li:nth-child(2) img {
        width: 22px;
    }
    .new_property_details_descontent_points ul li {
        width: 50%;
    }
    .new_property_details_descontent_property_details ul li span {
        width: 44%;
    }
    .new_property_details_descontent_property_details
        ul
        li:last-child
        span:last-child {
        width: 56%;
    }
    .new_property_details_extra_points ul li {
        line-height: 1.2;
    }
    .new_video_box {
        padding: 15px 4px;
    }
    .new_video_box_image img {
        width: 72%;
    }
    .new_video_box_button span {
        font-size: 24px;
        margin-top: 10px;
    }
    .new_video_box_button button img {
        width: 40px;
    }
    .new_banner_content_title h1 {
        font-size: 28px;
    }
    .new_banner_content_button a:last-child {
        margin-left: 0;
        margin-top: 18px;
    }
    .new_banner_side_image img {
        max-width: 133%;
        left: -53px;
        top: 145px;
    }
    .mer_custom2 {
        margin-top: 100px;
    }
    .new_property_details_bredc_content ul {
        flex-flow: wrap;
    }
    .oops_banner_content {
        margin-right: 16px;
    }
    .oops_banner_content_box {
        padding: 45px 20px 45px 38px;
    }
    .oops_banner_content h1 {
        font-size: 45px;
        margin-bottom: 15px;
    }
}

@media screen and (max-width: 767.98px) {
    .new_banner_content_title h1 {
        font-size: 42px;
    }
    .new_banner_content_price h2 {
        margin-bottom: 12px;
    }
    .new_banner_content_slide small {
        line-height: 1.3;
    }
    .new_banner_content_button {
        justify-content: center;
    }
    .new_banner_content_button a:last-child {
        margin-left: 0;
        margin-top: 15px;
    }
    .new_banner_side_image img {
        max-width: 100%;
        left: 0;
        top: 0;
        position: relative;
    }
    .new_property_details_share_content ul {
        flex-wrap: wrap;
    }
    .new_property_details_image_main img {
        height: 266px;
    }
    .new_property_details_image_main {
        margin-bottom: 15px;
    }
    .new_property_details_image_sub img {
        height: 245px;
    }
    .new_property_details_extra_points li:last-child {
        width: 21%;
    }
    .new_property_details_extra_points li {
        width: 68%;
    }
    .new_property_details_extra_points ul li:nth-child(2) {
        margin-top: 14px;
    }
    .new_property_details_extra_points ul li:nth-child(2) img {
        width: 17px;
    }
    .new_property_details_extra_price {
        text-align: center;
        margin-top: 29px;
    }
    .new_property_details_descontent_title h3,
    .new_property_details_descontent_amenities_title h3,
    .new_property_details_descontent_property_details_title h3 {
        font-size: 25px;
    }
    .new_banner_content_title h1 {
        font-size: 33px;
    }
    .new_banner_side_image img {
        max-width: 68%;
    }
    .new_banner_side_image {
        text-align: center;
        margin-top: 38px;
    }
    .new_comparable_home {
        margin-top: 34px;
    }
    .new_way_buy_home {
        padding: 22px 0 20px;
    }
    .new_way_buy_home_title h5 {
        font-size: 25px;
    }
    .new_way_buy_home_title span {
        font-size: 19px;
        margin-top: 14px;
    }
    .mer_custom {
        margin-top: 100px;
    }
    .more_fact_feature_box1,
    .more_fact_feature_box2 {
        width: 100%;
    }
    .oops_banner_content_box {
        padding: 35px;
    }
    .oops_banner_content {
        margin-right: 0px;
        text-align: center;
    }
}

@media screen and (max-width: 575.98px) {
}

@media screen and (max-width: 423.98px) {
    .new_banner_content_title h1 {
        font-size: 35px;
    }
    .new_banner_content_box {
        padding: 30px 17px;
    }
    .new_property_details_share_content ul {
        font-size: 16px;
    }
    .oops_banner_content_box {
        padding: 16px;
    }
}

@media screen and (max-width: 321.98px) {
    .new_banner_content_title h1 {
        font-size: 32px;
    }
    .new_banner_content_price h2 {
        font-size: 38px;
    }
    l.slider_price li {
        font-size: 15px;
    }
    .slider_bar:before {
        height: 7px;
    }
    .slider_bar_ball {
        height: 20px;
        width: 20px;
    }
    .slider_bar_ball:before {
        height: 20px;
        width: 20px;
    }
    .new_banner_content_price small {
        font-size: 14px;
    }
    .new_banner_content_slide small {
        font-size: 14px;
    }
    .new_banner_content_button a {
        font-size: 17px;
    }
    .new_property_details_share_content ul {
        font-size: 13px;
    }
    .new_property_details_bredc_content ul li a {
        font-size: 16px;
    }
    .new_property_details_image_main img {
        height: 195px;
    }
    .new_property_details_image_sub img {
        height: 180px;
    }
    .new_property_details_extra_points ul {
        font-size: 15px;
    }
    .new_custom_button {
        font-size: 15px;
    }
    .new_property_details_descontent_points ul li {
        width: 100%;
    }
    .new_property_details_descontent_amenities ul li {
        width: 100%;
    }
    .new_property_details_descontent_property_details ul li span {
        width: 53%;
    }
    .new_secude_form {
        padding: 25px 14px;
    }
    .new_video_box_button span {
        text-align: center;
    }
    ul.slider_price li {
        font-size: 15px;
    }
    .new_comparable_home .new_comparable_home_title span {
        font-size: 26px;
    }
    .new_way_buy_home_title span {
        font-size: 16px;
    }
}

@media screen and (max-width: 285.98px) {
}

@media screen and (max-width: 736.98px) {
}
</style>
